import { Flag } from "lucide-react";

const PROVINCES = [
  { value: "ON", label: "Ontario" },
  { value: "QC", label: "Quebec" },
  { value: "AB", label: "Alberta" },
  { value: "BC", label: "British Columbia" },
  { value: "MB", label: "Manitoba" },
  { value: "SK", label: "Saskatchewan" },
  { value: "NS", label: "Nova Scotia" },
  { value: "NB", label: "New Brunswick" },
  { value: "PE", label: "Prince Edward Island" },
  { value: "NL", label: "Newfoundland & Labrador" },
  { value: "NT", label: "Northwest Territories" },
  { value: "YT", label: "Yukon" },
  { value: "NU", label: "Nunavut" },
] as const;

export type Country = "US" | "CA";
export type Province = typeof PROVINCES[number]["value"];

export { PROVINCES };

export function CountryToggle({
  value,
  onChange,
}: {
  value: Country;
  onChange: (c: Country) => void;
}) {
  const base =
    "inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer min-h-[40px]";
  const active =
    "bg-white/[0.08] text-foreground border border-white/[0.12] shadow-sm";
  const inactive =
    "text-muted-foreground hover:text-foreground/80 hover:bg-white/[0.04] border border-transparent";

  return (
    <div className="flex items-center gap-1.5">
      <button
        type="button"
        onClick={() => onChange("US")}
        className={`${base} ${value === "US" ? active : inactive}`}
      >
        <Flag className="h-3.5 w-3.5" /> United States
      </button>
      <button
        type="button"
        onClick={() => onChange("CA")}
        className={`${base} ${value === "CA" ? active : inactive}`}
      >
        <Flag className="h-3.5 w-3.5" /> Canada
      </button>
    </div>
  );
}
